<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>MOOC</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">MOOC</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">MOOC</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">MOOCs through SWAYAM portal of UGC</h2>
                <p>SWAYAM (Study Web of Active Learning by Young and Aspiring Minds) is a program initiated by
                    Government of India and designed to achieve access, equity and quality. SWAYAM platform is
                    indigenously developed by Ministry of Human Resource Development (MHRD) and All India Council for
                    Technical Education (AICTE)</p>

                <p>Courses delivered through SWAYAM are available free of cost to the learners,however students wanting
                    certifications shall be registered,shall be offered a certificate on successful completion of the
                    course with nominal fee.At end each course,there will be an assessment of the student through
                    proctored examination and the marks/grades secured in this examination could be transferred to the
                    academic record of the students.</p>
                <img src="assets/img/content/swayam.png" />
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
